import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  const footerSections = [
    {
      title: t.footer.headhunter,
      links: [
        { name: t.footer.start, path: '/ai-headhunter' },
        { name: t.footer.possibilities, path: '/mogelijkheden' },
        { name: t.footer.vision, path: '/visie' }
      ]
    },
    {
      title: t.footer.tools,
      links: [
        { name: t.footer.match, path: '/tools/vacature-match' },
        { name: t.footer.letter, path: '/tools/motivatiebrief' },
        { name: t.footer.linkedin, path: '/tools/linkedin-check' },
        { name: t.footer.trainer, path: '/tools/gesprek-trainer' }
      ]
    },
    {
      title: t.footer.org,
      links: [
        { name: t.footer.about, path: '/over' },
        { name: t.footer.contact, path: '/contact' },
        { name: t.footer.privacyPolicy, path: '/privacy' },
        { name: t.footer.cookiePolicy, path: '/cookies' },
        { name: t.footer.termsOfService, path: '/terms' }
      ]
    }
  ];

  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-8">
              <div className="w-8 h-8 bg-brand-orange rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">V</span>
              </div>
              <span className="text-xl font-black text-brand-dark tracking-tighter">vacature.ai</span>
            </Link>
            <p className="text-sm text-gray-500 mb-6 leading-relaxed font-medium italic">
              {t.footer.tagline}
            </p>
          </div>

          {footerSections.map((section) => (
            <div key={section.title}>
              <h3 className="text-[10px] font-black text-brand-dark uppercase tracking-[0.2em] mb-8">
                {section.title}
              </h3>
              <ul className="space-y-4">
                {section.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm font-bold text-gray-400 hover:text-brand-orange transition-colors italic"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-gray-50 mt-20 pt-10">
          <p className="text-[10px] font-black text-gray-300 text-center uppercase tracking-[0.3em]">
            {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;